export var MOBILE_BREAKPOINT = 768;
export var TABLET_BREAKPOINT = 1024;
export var DESKTOP_BREAKPOINT = 1440;
export var ACTIVE_POINT_ANGLE = 36;
export var SLIDER_BREAKPOINTS = {
    0: {
        slidesPerView: 1.45,
        spaceBetween: 24,
    },
    480: {
        slidesPerView: 1.85,
        spaceBetween: 28,
    },
    768: {
        slidesPerView: 3,
        spaceBetween: 28,
    },
    1024: {
        slidesPerView: 3,
        spaceBetween: 48,
    },
    1440: {
        slidesPerView: 3,
        spaceBetween: 80,
    },
};
export function getTimelineRadius(viewportWidth) {
    if (viewportWidth < MOBILE_BREAKPOINT) {
        return 0;
    }
    if (viewportWidth < TABLET_BREAKPOINT) {
        return 180;
    }
    if (viewportWidth < DESKTOP_BREAKPOINT) {
        return 230;
    }
    return 265;
}
export function polarToCartesian(centerX, centerY, radius, angleDeg) {
    var angleRad = (angleDeg - 90) * (Math.PI / 180);
    return {
        x: centerX + radius * Math.cos(angleRad),
        y: centerY + radius * Math.sin(angleRad),
    };
}
